import React, { Component } from 'react'
import { normalizeHour } from '../../utils/util'
import Activity from '../Activity/Activity';
import './styles.sass'
import ActivityMobile from '../ActivityMobile/ActivityMobile';

export default class ResultsOfDay extends Component {

    constructor(props) {
        super(props)

        this.state = {
            openAllDay: false
        }
    }

    handleClick = (openAllDay) => {
        this.setState({
            openAllDay: openAllDay
        })
    }

    render() {
        const { resultsList, timeFrom, timeOf, labels } = this.props
        const { openAllDay } = this.state
        let existAllDay = false
        let existOfDay = false
        return (
            <div className="activity-results">
                {
                    resultsList.activityAllDay != undefined &&
                    <div className="activity-group bottom-line"><span className={`label-accordion ${openAllDay ? "open" : ""}`} onClick={() => this.handleClick(!openAllDay)}>{labels.sectionTitle_allDay} {resultsList.activityAllDay.length > 0 ? "("+resultsList.activityAllDay.length+" risultat"+(resultsList.activityAllDay.length > 1 ? "i" : "o")+")" : ""}</span>
                        <div className={`accordion-group group ${openAllDay ? "open" : ""}`}>
                            {
                                resultsList.activityAllDay.length > 0 &&
                                resultsList.activityAllDay.map((activity, index) => {



                                    return (
                                        <>
                                            <Activity labels={labels} activity={activity} />
                                            <ActivityMobile labels={labels} activity={activity} />
                                        </>
                                    )


                                })
                            }
                            {resultsList.activityAllDay.length == 0 ?
                                <div className="no-exist"><span>{labels.calendar_noResults_title} </span>{labels.calendar_noResults_subtitle2}</div>
                                :
                                <></>
                            }
                        </div>
                    </div>
                }
                {
                    resultsList.coursesOfDay != undefined &&
                    <div className="activity-group"><span>{labels.sectionTitle_courses} {resultsList.coursesOfDay.length > 0 ? "("+resultsList.coursesOfDay.length+" risultat"+(resultsList.coursesOfDay.length > 1 ? "i" : "o")+")" : ""}</span>
                        <div className="group">
                            {
                                resultsList.coursesOfDay.length > 0 &&
                                resultsList.coursesOfDay.map((activity, index) => {

                                    existOfDay = true
                                    return (
                                        <>
                                            <Activity labels={labels} activity={activity} />
                                            <ActivityMobile labels={labels} activity={activity} />
                                        </>
                                    )

                                })
                            }
                            {resultsList.coursesOfDay.length == 0 ?
                                <div className="no-exist"><span>{labels.calendar_noResults_title} </span>{labels.calendar_noResults_subtitle2}</div>
                                :
                                <></>
                            }
                        </div>
                    </div>
                }
                {
                    (resultsList.coursesOfDay == undefined) &&
                    <div className="no-results"><span>{labels.calendar_noResults_title}</span><br />{labels.calendar_noResults_subtitle}</div>
                }
            </div>
        )
    }
}
